<template>
    <div v-if="$checkRole($accessModule.order_tabs.service_report, 'read')" :class="{'run-loading': Loading}">
        <b-row no-gutters class="mt-15">
            <b-col md="12" class="text-right">
                <gofix-button v-if="!IsReadOnly && $checkRole($accessModule.order_tabs.service_report, 'create')" class="mb-15 gofixButtonFix" label="Add New Service Report +" outline :loading="loading.createGroup" @click="addNewServiceReport"></gofix-button>
            </b-col>
            <template v-for="(item, index) in groupServiceReports">
                <b-col md="12" class="mb-15" :key="index">
                    <gofix-card :title="item.name" class="pd-15" classHeader="pt-0 pl-0 mb-0" classContent="mb-0 pl-0 pr-0 mt-15" collapse>
                        <template slot="gofixCard:right_header">
                            <div class="d-flex justify-content-end align-items-center" v-if="!IsReadOnly && $checkRole($accessModule.order_tabs.service_report, 'delete') && item.id != 1">
                                <span  @click="confirmDeleteItem(item)" class="search pull-right">
                                    <img class="cursor-pointer" width="14" height="14" src="img/close.png" alt="delete">
                                </span>
                            </div>
                        </template>
                        <service-report class="mb-15" cardTitle="Action Taken" :isList="false" type="action_taken" :work_finding_action_taken_group_id="Number(item.id)"></service-report>
                        <service-report cardTitle="Work Findings" moduleRole="work_findings" type="work_finding" :work_finding_action_taken_group_id="Number(item.id)"></service-report>
                    </gofix-card>
                </b-col>
            </template>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modal.delete.open">
            <div class="center">Are you sure you want to<br/>delete <strong>This Service Report</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.delete.open = false">No</b-button>
                <b-button class="custom-btn" :disabled="modal.delete.loading" @click="deleteItem"> <b-spinner v-if="modal.delete.loading" small type="grow"></b-spinner> Yes</b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ServiceReport from './list.vue';
    export default {
        name: 'service-report-wf-and-at',
        components: {
            ServiceReport
        },
        data() {
            return{
                timer: {
                    edit: null,
                    delete: null,
                    createGroup: null
                },
                modal: {
                    delete: {
                        data: {
                            id: null,
                            order_id: null  
                        },
                        open: false,
                        loading: false
                    }
                },
                loading: {
                    createGroup: false
                }
            }
        },

        computed: {
            ...mapGetters({
                Item: 'OrderController/Item',
                groupServiceReports: "OrderServiceReportController/groupServiceReports",
                Loading: "OrderServiceReportController/Loading",
                IsReadOnly: 'OrderController/IsReadOnly',
            }),
            isAccess() {
                return this.$checkRole(this.$accessModule.order_tabs.service_report, 'update');
            }
        },
        created() {
            if(this.Item && this.Item.id)
                this.getItems();
        },
        watch: {
        },
        methods: {
            /* --- Work Finding --- */
            getItems() {
                this.$store.dispatch("OrderServiceReportController/getGroupServiceReport", {
                    order_id: this.Item.id
                })
            },
            addNewServiceReport() {
                if (this.timer.createGroup) {
                    clearTimeout(this.timer.createGroup);
                    this.timer.createGroup = null;
                }
                this.timer.createGroup = setTimeout(() => {
                    if (this.loading.createGroup) return;
                    this.loading.createGroup = true;

                    this.$store.dispatch("OrderServiceReportController/createGroupServiceReport", {
                        order_id:   this.Item.id
                    })
                    .then(async (result) => {
                        await this.getItems();
                        this.loading.createGroup = false;
                        this.$alertNotification(this.$notificationV2("adding", "order_service_report"));
                    })
                    .catch(error => {
                        this.loading.createGroup = false;
                    });
                }, 100)
            },
            confirmDeleteItem(item) {
                this.modal.delete.data.order_id = this.Item.id
                this.modal.delete.data.id = item.id
                this.modal.delete.loading = false
                this.modal.delete.open = true;
            },
            deleteItem() {
                if (this.timer.delete) {
                    clearTimeout(this.timer.delete);
                    this.timer.delete = null;
                }
                this.timer.delete = setTimeout(() => {
                    this.modal.delete.loading = true;
                    this.$store.dispatch('OrderServiceReportController/deleteGroupServiceReport', this.modal.delete.data)
                    .then(response => {
                        this.modal.delete.open    = false;
                        this.modal.delete.loading = false;
                        this.getItems();
                        this.$alertNotification(this.$notificationV2('deleting', 'order_service_report'));
                    })
                    .catch(error => {
                        this.modal.delete.loading = false;
                        console.log(error);
                    });
                }, 100)
            },
        }
    }
</script>
